import './index.scss'
import { Expandable } from './../../js/Expandable.js'

class Faq {
    constructor(el) {
        this.$el = el
    }
    init() {
             
        const faqs = this.$el.querySelectorAll('.oce-faq__answer');
        
        faqs.forEach(faq => new Expandable(faq));
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.oce-faq') ].forEach($block => {
        $block.expandygg = new Faq($block)
    })
}, {capture: false, passive: true, once: true} || false)